"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabUnderline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _TabUnderlineStyled = require("./TabUnderlineStyled");
const TabUnderline = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(_TabUnderlineStyled.TabUnderlineStyled, (0, _extends2.default)({
    themeMode: themeMode,
    ref: ref
  }, props));
});
exports.TabUnderline = TabUnderline;
TabUnderline.displayName = "TabUnderline";
//# sourceMappingURL=TabUnderline.js.map